(() => {
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) => {
    const c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'lv', { style: 'currency', currency: c }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + c; }
  };
  const openDrawer = (el) => { if (!el) return; el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
  const closeDrawer = (el) => { if (!el) return; el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); openDrawer(document.getElementById(open.dataset.open)); return; }
    const close = e.target.closest('[data-close]');
    if (close) { e.preventDefault(); closeDrawer(close.closest('.drawer')); return; }
    if (e.target.classList.contains('drawer__scrim')) closeDrawer(e.target.closest('.drawer'));
    const st = e.target.closest('[data-search-toggle]');
    if (st) { const s = document.querySelector('[data-search]'); if (s) { s.classList.toggle('is-open'); const i = s.querySelector('input'); if (i) i.focus(); } }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('.drawer[aria-hidden="false"]').forEach(closeDrawer);
  });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('.qty button');
    if (!b) return;
    e.preventDefault();
    const input = b.parentElement.querySelector('input');
    const step = b.dataset.dir === 'up' ? 1 : -1;
    const min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    const bar = document.querySelector('[data-ship-bar]');
    if (bar) {
      const goal = parseInt(bar.dataset.goal, 10) || 0;
      const left = Math.max(0, goal - cart.total_price);
      const fill = bar.querySelector('.ship-bar__fill');
      if (fill) fill.style.width = goal ? Math.min(100, (cart.total_price / goal) * 100) + '%' : '0%';
      const msg = bar.querySelector('[data-ship-msg]');
      if (msg) msg.textContent = left > 0 ? bar.dataset.away.replace('[amount]', money(left)) : bar.dataset.done;
    }
    const body = document.querySelector('[data-cart-lines]');
    if (!body) return;
    if (!cart.items.length) { body.innerHTML = '<p>' + body.dataset.empty + '</p>'; return; }
    body.innerHTML = cart.items.map((i) => `
      <div class="mini">
        ${i.image ? `<img src="${i.image.replace(/(\.[a-z]+)(\?|$)/i, '_150x$2')}" alt="" width="74" height="98">` : '<span class="mini__ph"></span>'}
        <div>
          <p class="mini__title"><a href="${i.url}">${i.product_title}</a></p>
          ${i.variant_title ? `<p class="mini__meta">${i.variant_title}</p>` : ''}
          <p class="mini__meta">${i.quantity} &times; ${money(i.final_price)}</p>
          <button class="mini__remove" data-remove="${i.key}">${body.dataset.remove}</button>
        </div>
      </div>`).join('');
  };

  const fetchCart = () => fetch(root() + 'cart.js').then((r) => r.json()).then(renderCart).catch(() => {});

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    fetch(root() + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 })
    }).then((r) => r.json()).then(renderCart);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    fetch(root() + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(() => { window.location.href = root() + 'checkout'; })
      .catch(() => { btn.removeAttribute('aria-disabled'); form.submit(); });
  });

  document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      const btn = form.querySelector('[data-add]');
      if (btn) btn.setAttribute('aria-disabled', 'true');
      fetch(root() + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then((r) => r.json())
        .then(() => fetchCart())
        .then(() => openDrawer(document.getElementById('cart-drawer')))
        .finally(() => { if (btn) btn.removeAttribute('aria-disabled'); });
    });
  });

  if (document.querySelector('[data-cart-lines]')) fetchCart();
})();
